import { subscribe as Ee } from "@seamless/one-context";
import { ref as m, computed as E, toValue as v, watch as I, useSSRContext as Ze, onMounted as $, onBeforeUnmount as Ne, onErrorCaptured as Ke, getCurrentInstance as Ie, onUnmounted as Je, getCurrentScope as Xe, onScopeDispose as et, shallowRef as ge, onBeforeMount as tt } from "vue";
import { initializeLogger as $e } from "@seamless/logger";
import { initializeStore as ve, SeamlessConnection as Pe } from "@seamless/store";
import { getTranslation as Q } from "@owc/aem-translations-util";
import { u as dr } from "./useUuid-BGpRkYny.js";
var T = /* @__PURE__ */ ((e) => (e.MERCEDES_BENZ = "Mercedes-Benz", e.MERCEDES_AMG = "Mercedes-AMG", e.MERCEDES_MAYBACH = "Mercedes-Maybach", e))(T || {}), _ = /* @__PURE__ */ ((e) => (e.MERCEDES_BENZ = "MERCEDES_BENZ", e.MERCEDES_AMG = "MERCEDES_AMG", e.MERCEDES_MAYBACH = "MERCEDES_MAYBACH", e.MERCEDESBENZ = "Mercedes-Benz", e.MERCEDESAMG = "Mercedes-AMG", e.MERCEDESMAYBACH = "Mercedes-Maybach", e))(_ || {}), ce = /* @__PURE__ */ ((e) => (e.AMG = "amg", e.MAYBACH = "maybach", e))(ce || {}), Y;
// @__NO_SIDE_EFFECTS__
function nt(e) {
  return {
    lang: e?.lang ?? Y?.lang,
    message: e?.message,
    abortEarly: e?.abortEarly ?? Y?.abortEarly,
    abortPipeEarly: e?.abortPipeEarly ?? Y?.abortPipeEarly
  };
}
var rt;
// @__NO_SIDE_EFFECTS__
function at(e) {
  return rt?.get(e);
}
var ot;
// @__NO_SIDE_EFFECTS__
function st(e) {
  return ot?.get(e);
}
var it;
// @__NO_SIDE_EFFECTS__
function ct(e, t) {
  return it?.get(e)?.get(t);
}
// @__NO_SIDE_EFFECTS__
function Be(e) {
  const t = typeof e;
  return t === "string" ? `"${e}"` : t === "number" || t === "bigint" || t === "boolean" ? `${e}` : t === "object" || t === "function" ? (e && Object.getPrototypeOf(e)?.constructor?.name) ?? "null" : t;
}
function w(e, t, n, r, s) {
  const c = s && "input" in s ? s.input : n.value, a = s?.expected ?? e.expects ?? null, i = s?.received ?? /* @__PURE__ */ Be(c), o = {
    kind: e.kind,
    type: e.type,
    input: c,
    expected: a,
    received: i,
    message: `Invalid ${t}: ${a ? `Expected ${a} but r` : "R"}eceived ${i}`,
    requirement: e.requirement,
    path: s?.path,
    issues: s?.issues,
    lang: r.lang,
    abortEarly: r.abortEarly,
    abortPipeEarly: r.abortPipeEarly
  }, u = e.kind === "schema", l = s?.message ?? e.message ?? /* @__PURE__ */ ct(e.reference, o.lang) ?? (u ? /* @__PURE__ */ st(o.lang) : null) ?? r.message ?? /* @__PURE__ */ at(o.lang);
  l !== void 0 && (o.message = typeof l == "function" ? (
    // @ts-expect-error
    l(o)
  ) : l), u && (n.typed = !1), n.issues ? n.issues.push(o) : n.issues = [o];
}
// @__NO_SIDE_EFFECTS__
function L(e) {
  return {
    version: 1,
    vendor: "valibot",
    validate(t) {
      return e["~run"]({ value: t }, /* @__PURE__ */ nt());
    }
  };
}
// @__NO_SIDE_EFFECTS__
function ut(e, t) {
  const n = [...new Set(e)];
  return n.length > 1 ? `(${n.join(` ${t} `)})` : n[0] ?? "never";
}
// @__NO_SIDE_EFFECTS__
function z(e, t) {
  return {
    kind: "validation",
    type: "max_length",
    reference: z,
    async: !1,
    expects: `<=${e}`,
    requirement: e,
    message: t,
    "~run"(n, r) {
      return n.typed && n.value.length > this.requirement && w(this, "length", n, r, {
        received: `${n.value.length}`
      }), n;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function V(e, t) {
  return {
    kind: "validation",
    type: "min_length",
    reference: V,
    async: !1,
    expects: `>=${e}`,
    requirement: e,
    message: t,
    "~run"(n, r) {
      return n.typed && n.value.length < this.requirement && w(this, "length", n, r, {
        received: `${n.value.length}`
      }), n;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function be(e, t) {
  return {
    kind: "validation",
    type: "regex",
    reference: be,
    async: !1,
    expects: `${e}`,
    requirement: e,
    message: t,
    "~run"(n, r) {
      return n.typed && !this.requirement.test(n.value) && w(this, "format", n, r), n;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Ge(e, t, n) {
  return typeof e.fallback == "function" ? (
    // @ts-expect-error
    e.fallback(t, n)
  ) : (
    // @ts-expect-error
    e.fallback
  );
}
// @__NO_SIDE_EFFECTS__
function lt(e, t) {
  return {
    ...e,
    fallback: t,
    get "~standard"() {
      return /* @__PURE__ */ L(this);
    },
    "~run"(n, r) {
      const s = e["~run"](n, r);
      return s.issues ? { typed: !0, value: /* @__PURE__ */ Ge(this, s, r) } : s;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function xe(e, t, n) {
  return typeof e.default == "function" ? (
    // @ts-expect-error
    e.default(t, n)
  ) : (
    // @ts-expect-error
    e.default
  );
}
// @__NO_SIDE_EFFECTS__
function Se(e, t) {
  return {
    kind: "schema",
    type: "array",
    reference: Se,
    expects: "Array",
    async: !1,
    item: e,
    message: t,
    get "~standard"() {
      return /* @__PURE__ */ L(this);
    },
    "~run"(n, r) {
      const s = n.value;
      if (Array.isArray(s)) {
        n.typed = !0, n.value = [];
        for (let c = 0; c < s.length; c++) {
          const a = s[c], i = this.item["~run"]({ value: a }, r);
          if (i.issues) {
            const o = {
              type: "array",
              origin: "value",
              input: s,
              key: c,
              value: a
            };
            for (const u of i.issues)
              u.path ? u.path.unshift(o) : u.path = [o], n.issues?.push(u);
            if (n.issues || (n.issues = i.issues), r.abortEarly) {
              n.typed = !1;
              break;
            }
          }
          i.typed || (n.typed = !1), n.value.push(i.value);
        }
      } else
        w(this, "type", n, r);
      return n;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function D(e, t) {
  return {
    kind: "schema",
    type: "literal",
    reference: D,
    expects: /* @__PURE__ */ Be(e),
    async: !1,
    literal: e,
    message: t,
    get "~standard"() {
      return /* @__PURE__ */ L(this);
    },
    "~run"(n, r) {
      return n.value === this.literal ? n.typed = !0 : w(this, "type", n, r), n;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function je(e, t) {
  return {
    kind: "schema",
    type: "nullish",
    reference: je,
    expects: `(${e.expects} | null | undefined)`,
    async: !1,
    wrapped: e,
    default: t,
    get "~standard"() {
      return /* @__PURE__ */ L(this);
    },
    "~run"(n, r) {
      return (n.value === null || n.value === void 0) && (this.default !== void 0 && (n.value = /* @__PURE__ */ xe(this, n, r)), n.value === null || n.value === void 0) ? (n.typed = !0, n) : this.wrapped["~run"](n, r);
    }
  };
}
// @__NO_SIDE_EFFECTS__
function H(e, t) {
  return {
    kind: "schema",
    type: "object",
    reference: H,
    expects: "Object",
    async: !1,
    entries: e,
    message: t,
    get "~standard"() {
      return /* @__PURE__ */ L(this);
    },
    "~run"(n, r) {
      const s = n.value;
      if (s && typeof s == "object") {
        n.typed = !0, n.value = {};
        for (const c in this.entries) {
          const a = this.entries[c];
          if (c in s || (a.type === "exact_optional" || a.type === "optional" || a.type === "nullish") && // @ts-expect-error
          a.default !== void 0) {
            const i = c in s ? (
              // @ts-expect-error
              s[c]
            ) : /* @__PURE__ */ xe(a), o = a["~run"]({ value: i }, r);
            if (o.issues) {
              const u = {
                type: "object",
                origin: "value",
                input: s,
                key: c,
                value: i
              };
              for (const l of o.issues)
                l.path ? l.path.unshift(u) : l.path = [u], n.issues?.push(l);
              if (n.issues || (n.issues = o.issues), r.abortEarly) {
                n.typed = !1;
                break;
              }
            }
            o.typed || (n.typed = !1), n.value[c] = o.value;
          } else if (a.fallback !== void 0)
            n.value[c] = /* @__PURE__ */ Ge(a);
          else if (a.type !== "exact_optional" && a.type !== "optional" && a.type !== "nullish" && (w(this, "key", n, r, {
            input: void 0,
            expected: `"${c}"`,
            path: [
              {
                type: "object",
                origin: "key",
                input: s,
                key: c,
                // @ts-expect-error
                value: s[c]
              }
            ]
          }), r.abortEarly))
            break;
        }
      } else
        w(this, "type", n, r);
      return n;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function F(e) {
  return {
    kind: "schema",
    type: "string",
    reference: F,
    expects: "string",
    async: !1,
    message: e,
    get "~standard"() {
      return /* @__PURE__ */ L(this);
    },
    "~run"(t, n) {
      return typeof t.value == "string" ? t.typed = !0 : w(this, "type", t, n), t;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Ce(e) {
  let t;
  if (e)
    for (const n of e)
      t ? t.push(...n.issues) : t = n.issues;
  return t;
}
// @__NO_SIDE_EFFECTS__
function He(e, t) {
  return {
    kind: "schema",
    type: "union",
    reference: He,
    expects: /* @__PURE__ */ ut(
      e.map((n) => n.expects),
      "|"
    ),
    async: !1,
    options: e,
    message: t,
    get "~standard"() {
      return /* @__PURE__ */ L(this);
    },
    "~run"(n, r) {
      let s, c, a;
      for (const i of this.options) {
        const o = i["~run"]({ value: n.value }, r);
        if (o.typed)
          if (o.issues)
            c ? c.push(o) : c = [o];
          else {
            s = o;
            break;
          }
        else
          a ? a.push(o) : a = [o];
      }
      if (s)
        return s;
      if (c) {
        if (c.length === 1)
          return c[0];
        w(this, "type", n, r, {
          issues: /* @__PURE__ */ Ce(c)
        }), n.typed = !0;
      } else {
        if (a?.length === 1)
          return a[0];
        w(this, "type", n, r, {
          issues: /* @__PURE__ */ Ce(a)
        });
      }
      return n;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function he(...e) {
  return {
    ...e[0],
    pipe: e,
    get "~standard"() {
      return /* @__PURE__ */ L(this);
    },
    "~run"(t, n) {
      for (const r of e)
        if (r.kind !== "metadata") {
          if (t.issues && (r.kind === "schema" || r.kind === "transformation")) {
            t.typed = !1;
            break;
          }
          (!t.issues || !n.abortEarly && !n.abortPipeEarly) && (t = r["~run"](t, n));
        }
      return t;
    }
  };
}
const qe = /^[a-zA-Z]{2}$/, dt = /* @__PURE__ */ he(
  /* @__PURE__ */ F(),
  /* @__PURE__ */ V(2),
  /* @__PURE__ */ z(2),
  /* @__PURE__ */ be(qe, "Must match two-letter pattern")
), ft = /* @__PURE__ */ he(
  /* @__PURE__ */ F(),
  /* @__PURE__ */ V(2),
  /* @__PURE__ */ z(2),
  /* @__PURE__ */ be(qe, "Must match two-letter pattern")
), pt = /* @__PURE__ */ je(/* @__PURE__ */ he(/* @__PURE__ */ F(), /* @__PURE__ */ V(3), /* @__PURE__ */ z(5))), ze = /* @__PURE__ */ lt(
  /* @__PURE__ */ He([
    /* @__PURE__ */ D("MERCEDES_BENZ"),
    /* @__PURE__ */ D("MERCEDES_AMG"),
    /* @__PURE__ */ D("MERCEDES_MAYBACH"),
    /* @__PURE__ */ D("Mercedes-Benz"),
    /* @__PURE__ */ D("Mercedes-AMG"),
    /* @__PURE__ */ D("Mercedes-Maybach")
  ]),
  "Mercedes-Benz"
), mt = /* @__PURE__ */ H({
  lang: dt,
  market: ft,
  stage: pt,
  brand: /* @__PURE__ */ Se(ze)
});
({
  ...mt.entries,
  ...(/* @__PURE__ */ H({ brand: /* @__PURE__ */ Se(ze) })).entries
});
function Et(e) {
  switch (e) {
    case T.MERCEDES_AMG:
    case _.MERCEDES_AMG:
    case _.MERCEDESAMG:
    case ce.AMG:
      return T.MERCEDES_AMG;
    case T.MERCEDES_MAYBACH:
    case _.MERCEDES_MAYBACH:
    case _.MERCEDESMAYBACH:
    case ce.MAYBACH:
      return T.MERCEDES_MAYBACH;
    default:
      return T.MERCEDES_BENZ;
  }
}
function Pn(e) {
  const t = m(null), n = m(null), r = E(() => {
    const c = v(e) ?? t.value ?? n.value;
    return Et(c);
  });
  Ee("PageConnection", {
    tenant: "sccs",
    componentName: "sccs-one-teaser",
    callback: (c) => {
      n.value = c.pageEnvironmentVariables.vehicleData?.subBrands[0], t.value = c.pageEnvironmentVariables.brand?.subBrand;
    }
  });
  const s = E(() => {
    switch (r?.value) {
      case T.MERCEDES_AMG:
        return _.MERCEDESAMG;
      case T.MERCEDES_MAYBACH:
        return _.MERCEDESMAYBACH;
      default:
        return _.MERCEDESBENZ;
    }
  });
  return { subBrand: r, brandUrlParameter: s };
}
function gt(e) {
  switch (e?.toLowerCase()?.trim() ?? "prod") {
    case "dev":
    case "development":
    case "local":
    case "localhost":
      return "TEST";
    case "int":
    case "integration":
    case "test":
    case "testing":
      return "INT";
    case "pprod":
    case "preprod":
    case "pre-production":
    case "preproduction":
      return "PPROD";
    case "prod":
    case "production":
      return "PROD";
    default:
      return "LOCAL";
  }
}
function vt(e) {
  return e.toLowerCase().trim();
}
const Bn = "fe-vehicle-tiles", W = "fe-one-teaser-platform", bt = {
  LOCAL: "https://assets.oneweb.mercedes-benz.com",
  TEST: "https://dev.assets.oneweb.mercedes-benz.com",
  INT: "https://int.assets.oneweb.mercedes-benz.com",
  PPROD: "https://preprod.assets.oneweb.mercedes-benz.com",
  PROD: "https://assets.oneweb.mercedes-benz.com"
};
function St(e, t, n) {
  const r = bt[gt(e) ?? "PROD"], s = vt(t);
  return `${r}/config/emh/${n}/${s}/config.json`;
}
const C = $e("DH_IO_SCSS/CONFIG_SERVICE_OT");
async function ht(e) {
  const t = new Request(e);
  try {
    return await fetch(t);
  } catch (n) {
    return C.warn("Error fetching config from network", n), Response.error();
  }
}
let Z = null;
function Gn(e) {
  const t = m(null), n = m(!0), r = m(null), s = new URLSearchParams(window.location.search), c = (g, b, h, R) => {
    const O = W + "_" + g + "_" + b, k = s.get(O), N = k ? ["t", "true"].includes(k.toLocaleLowerCase()) : void 0, p = N ?? h ?? R;
    return C.log(W + "_" + g + "_" + b + " set to " + p, {
      urlParamResult: N,
      configServiceResult: h,
      fallback: R
    }), p;
  }, a = E(() => !n.value), i = E(
    () => c("focMarket", "isFocMarket", t.value?.focMarket?.isFocMarket, !1)
  ), o = E(
    () => c(
      "personalization",
      "personalizationEnabled",
      t.value?.personalization?.personalizationEnabled,
      !1
    )
  ), u = E(
    () => c(
      "switchToOneTeaser",
      "enableOneTeaserHome",
      t.value?.switchToOneTeaser?.enableOneTeaserHome,
      !0
    )
  ), l = E(
    () => c(
      "switchToOneTeaser",
      "enableOneTeaserCampaign",
      t.value?.switchToOneTeaser?.enableOneTeaserCampaign,
      !0
    )
  ), d = E(
    () => c("config", "failOnMissingPrice", t.value?.config?.failOnMissingPrice, !0)
  ), f = E(
    () => c("config", "useCurrentEnv", t.value?.config?.useCurrentEnv, !0)
  );
  async function S() {
    n.value = !0, r.value = null, A().then((g) => {
      if (g) {
        if (g.error)
          throw C.warn("fetching configs failed", g.error), g.error;
        t.value = g.body, n.value = !1, C.log("configs set", t.value, e.stage, e.country);
      }
    });
  }
  async function A() {
    return t.value ? (C.log("configs already loaded"), { body: t.value, error: null }) : (Z ? C.log("configs already loaded by another component, using that response") : (C.log("fetching configs"), Z = new Promise((g) => {
      (async () => {
        try {
          const b = v(e.stage), h = v(e.country);
          if (!b || !h) {
            g(null), C.log("stage or country missing", b, h);
            return;
          }
          const R = St(b, h, W), O = await ht(R);
          if (!O?.ok) {
            g({
              body: null,
              error: new Error(`HTTP error, failed to load config! status: ${O?.status}`)
            });
            return;
          }
          const k = await O.json();
          C.log("configs fetched", k), g({ body: k, error: null });
        } catch (b) {
          C.warn("unknown error occured", b), g({ body: null, error: new Error("Unknown error occurred") });
        }
      })();
    })), Z);
  }
  return I(
    [e.stage, e.country],
    ([g, b]) => {
      !g || !b || S();
    },
    {
      immediate: !0
    }
  ), {
    isFeatureToggleLoaded: a,
    isFocMarket: i,
    isPersonalizationEnabled: o,
    isOneTeaserHomeEnabled: u,
    isOneTeaserCampaignEnabled: l,
    isFailOnMissingPriceEnabled: d,
    isUseCurrentEnvEnabled: f
  };
}
/*! aem-component-data-util 1.1.0 */
function yt(e) {
  if (!(typeof window < "u")) {
    const n = Ze()?.AEMContext;
    return { payload: n?.payload, config: n?.config };
  }
  const t = (window.top || window).aemNamespace.componentData;
  return e ? Array.isArray(e) ? Object.fromEntries(e.map(((n) => [n, t[n]]))) : t[e] : t;
}
const xn = (e, t = {
  reactive: !0
}) => {
  const n = m([]), r = m(null);
  function s(c) {
    const a = c.querySelector("[data-slot-outlet]");
    if (!a || !a.children.length) return;
    const i = a.children[0].localName === "slot" ? a.children[0].assignedElements() : a.children, o = Array.from(i || []).map(
      (u) => u?.getAttribute("component-id")
    );
    n.value = [];
    for (const u of o) {
      if (!u) continue;
      const l = { payload: yt(u).payload, componentId: u };
      n.value.push(l);
    }
  }
  return $(() => {
    const c = v(e);
    if (!c || (s(c), !t.reactive)) return;
    r.value?.disconnect();
    const a = { childList: !0, subtree: !0 }, i = (u) => {
      u.some((d) => d.type === "childList") && s(c);
    };
    r.value = new MutationObserver(i);
    const o = c?.querySelector("[data-slot-outlet]");
    o && r.value.observe(o, a);
  }), { childElementConfigs: n, syncConfigs: s };
}, K = {
  separator: "-",
  id: "35e68f8b5769ffbe51d5e3e245f7498f"
}, J = {
  separator: "-",
  id: "256327257efa0b223e1fa85ba6b0cbf7"
}, X = {
  separator: "_",
  id: "42b5f1b854ae37cc8b351c232bf6cb79"
}, Ct = "SCCS_MBTI-DISCO-AIR", jn = ["Mercedes-AMG", "MERCEDES_AMG"], Hn = Symbol.for("componentId"), qn = "Mercedes-Benz";
function zn(e, t, n = ve()) {
  const r = m();
  let s;
  const { unsubscribe: c } = n.subscribe(Ct, (o) => {
    s = o, i(v(e), v(t));
  });
  function a(o) {
    return r.value?.tileData && r.value?.state === "SUCCESS" && r.value?.inflateId === o;
  }
  function i(o, u) {
    if (o) {
      if (u) {
        r.value = {
          tileData: { ...u, state: "SUCCESS" },
          state: "SUCCESS",
          inflateId: o
        };
        return;
      }
      if (!a(o)) {
        if (!s || o && !s?.tileData?.[o])
          r.value = {
            // waiting for connection
            state: "PENDING",
            inflateId: o ?? "no-inflate-id-could-be-determined"
          };
        else if (o) {
          const l = s?.tileData?.[o], d = l?.state;
          r.value = {
            tileData: l,
            state: d,
            inflateId: o
          };
        }
      }
    }
  }
  return I(
    [() => v(e), () => v(t)],
    ([o, u]) => {
      i(o, u);
    },
    { immediate: !0 }
  ), { tileDataBundle: r, unsubscribe: c };
}
async function wt(e) {
  return new Promise((t) => {
    Ee("PageConnection", {
      tenant: "sccs",
      componentName: "air-tnt",
      callback: (n) => {
        t(`${n.pageEnvironmentVariables.language}${e}${n.pageEnvironmentVariables.country}`);
      }
    });
  });
}
async function At() {
  return new Promise((e) => {
    Ee("PageConnection", {
      tenant: "sccs",
      componentName: "air-tnt",
      callback: (t) => {
        e(t.pageEnvironmentVariables.country);
      }
    });
  });
}
const Mt = async (e) => await wt(e), Vn = async () => await At(), ee = $e("DH_IO_SCSS/I18N");
let te = null;
const G = m({}), x = m({}), ne = m({});
function Fn() {
  const e = async (a) => {
    let i = await Mt(a);
    return i === `de${a}AQ` && (i = `de${a}DE`), i === `en${a}AQ` && (i = `en${a}AU`), i;
  };
  async function t() {
    return te ? ee.log("translations already loaded by another component, using that response") : (ee.log("fetching translations"), te = new Promise((a) => {
      (async () => {
        try {
          G.value = await Q(
            await e(X.separator),
            X.id,
            "i18next"
          );
        } catch (i) {
          console.warn(
            `CMN_I18N_CMP: Failed to fetch compare translations for market ${await e(X.separator)}`,
            { cause: i }
          );
        }
        try {
          x.value = await Q(
            await e(K.separator),
            K.id,
            "i18next"
          );
        } catch (i) {
          console.warn(
            `CMN_I18N_DCP: Failed to fetch DCP translations for market ${await e(K.separator)}`,
            { cause: i }
          );
        }
        try {
          ne.value = await Q(
            await e(J.separator),
            J.id,
            "i18next"
          );
        } catch (i) {
          console.warn(
            `CMN_I18N_OT: Failed to fetch OneTeaser translations for market ${await e(J.separator)}`,
            { cause: i }
          );
        }
        ee.log("translations loaded", {
          compareTranslations: G.value,
          dcpTranslations: x.value,
          oneTeaserTranslations: ne.value
        }), a();
      })();
    })), te;
  }
  function n(a) {
    return !!s(a, G.value) || !!s(a, x.value);
  }
  function r(a, i) {
    if (!a)
      return "";
    const o = s(a, G.value) || s(a, x.value) || s(a, ne.value) || a;
    return c(o, i);
  }
  function s(a, i) {
    const o = a.split(".");
    let u = i;
    for (const l of o) {
      if (u === void 0 || typeof u == "string") return;
      u = u[l];
    }
    if (typeof u == "string")
      return u;
  }
  function c(a, i) {
    if (!i)
      return a;
    let o = a;
    return Object.entries(i).forEach((u) => {
      const [l, d] = u;
      o = o.replace(`{{${l}}}`, d), o = o.replace(`{{ ${l} }}`, d), o = o.replace(`{${l}}`, d), o = o.replace(`{ ${l} }`, d);
    }), o;
  }
  return { loadTranslations: t, t: r, existsWithoutFallback: n };
}
/*! connection-aem-environment 2.8.0 */
const Ve = "OWC_AEM_ENV", Tt = new class extends Pe {
  constructor() {
    super(Ve);
  }
  get initialState() {
    const e = window.aemNamespace?.environmentVariables || window.top?.aemNamespace?.environmentVariables, t = window.aemNamespace?.pageEnvironmentVariables || window.top?.aemNamespace?.pageEnvironmentVariables;
    return e && t ? { ...e, ...t } : {};
  }
  getReducer() {
    return () => this.initialState;
  }
  getPublicDispatchers() {
    return {};
  }
}(), _t = async () => {
  const e = ve();
  return await (async () => {
    if (!window.top?.aemNamespace && !window.aemNamespace) return new Promise(((t) => {
      let n;
      Object.defineProperty(window.top, "aemNamespace", { get: () => n, async set(r) {
        n = r, t();
      } });
    }));
  })(), await (async () => {
    if (!window.top?.aemNamespace?.environmentVariables && !window?.aemNamespace?.environmentVariables) return new Promise(((t) => {
      let n;
      Object.defineProperty(window.top?.aemNamespace, "environmentVariables", { get: () => n, set(r) {
        n = r, t();
      } });
    }));
  })(), await (async () => {
    if (!window.top?.aemNamespace?.pageEnvironmentVariables && !window?.aemNamespace?.pageEnvironmentVariables) return new Promise(((t) => {
      let n;
      Object.defineProperty(window.top?.aemNamespace, "pageEnvironmentVariables", { get: () => n, set(r) {
        n = r, t();
      } });
    }));
  })(), e.addConnection(Tt);
};
function Lt(e, t, n) {
  return !t || !n ? "" : `${t}${e[1]}${n}`;
}
const we = m(""), ue = m(""), le = m(""), Ae = m(!1), Rt = E(() => Lt`${le.value}_${ue.value}`);
function Un(e) {
  let t;
  return $(async () => {
    _t(), t = await e.subscribe(
      Ve,
      (n) => {
        we.value = n.stage, ue.value = n.country, le.value = n.language, Ae.value = !0;
      }
    ).unsubscribe;
  }), Ne(() => {
    t?.();
  }), {
    environment: we,
    country: ue,
    language: le,
    marketId: Rt,
    aemLoaded: Ae
  };
}
function Qn(e) {
  const t = E(() => v(e) === "campaign"), n = E(() => v(e) === "overlapping"), r = E(() => v(e) === "workbench7"), s = E(() => v(e) === "compact"), c = E(() => v(t) || n.value || r.value ? "classic" : "compact"), a = E(() => v(c) === "classic");
  return {
    isAppearanceCampaign: t,
    isAppearanceOverlapping: n,
    isAppearanceWorkbench: r,
    isAppearanceCompact: s,
    cssProject: c,
    useWbClasses: a
  };
}
function Me(e) {
  throw Error(e);
}
var Ot = /* @__PURE__ */ ((e) => (e[e.COMPONENT = 1] = "COMPONENT", e[e.DATALOADING = 2] = "DATALOADING", e[e.IMAGE = 3] = "IMAGE", e[e.PLS = 4] = "PLS", e[e.FCIS = 5] = "FCIS", e))(Ot || {}), kt = /* @__PURE__ */ ((e) => (e.CRITICAL = "CRITICAL", e.HIGH = "HIGH", e.MEDIUM = "MEDIUM", e.LOW = "LOW", e))(kt || {});
function Dt({ error: e, severity: t, component: n, message: r }, s) {
  const c = e.cause.message;
  switch (t) {
    case "CRITICAL":
    case "HIGH":
      s?.error("An error has been encountered, please find more information below"), s?.table({
        severity: t,
        category: n,
        message: r,
        cause: c
      });
      break;
    case "MEDIUM":
    case "LOW":
    default:
      s?.log(`Error in component ${n} with severity ${t}: ${r}`, e);
      break;
  }
}
const Yn = (e) => {
  const t = m(/* @__PURE__ */ new Map());
  Ke((a, i, o) => {
    const u = i, l = u._.type.__name === "ErrorBoundary" ? Ie() ?? Me("could not find vue instance") : u._, d = l.exposed?.severity ?? "CRITICAL", f = l.exposed?.category ?? 1, S = { error: a, severity: d, component: f, message: a.message };
    if (n(l, S), Dt(S, e.logger), e.onErrorCallback?.(), !e.allowPropagation) return !1;
  }), $(() => {
    r();
  }), Je(() => {
    r();
  });
  function n(a, { error: i, severity: o, component: u }) {
    const l = a.type.name ?? a.type.__name ?? Me("a component catching errors must have a name");
    if (t.value.has(l)) {
      const d = t.value.get(l);
      if (!d) return;
      t.value.set(l, [
        ...d,
        { error: i, severity: o, component: u, message: i?.message ?? "" }
      ]);
    } else
      t.value.set(l, [
        { error: i, severity: o, component: u, message: i?.message ?? "" }
      ]);
  }
  function r() {
    t.value.clear();
  }
  const s = E(() => !!t.value.size), c = E(() => Array.from(t.value.values()).reduce((a, i) => a + i.length, 0));
  return { componentsWithErrors: t, hasErrors: s, errorCount: c };
};
/**
* @preserve
* Licenses of bundled dependencies can be found in dependencies-licenses.txt
*/
const Nt = { attributes: !0, childList: !1, subtree: !1, attributeFilter: ["dir"] };
class It {
  constructor(t) {
    this.targetEl = t, this.createObserver(), this.observe();
  }
  setDir(t) {
    this.targetEl.setAttribute("dir", t);
  }
  get dir() {
    return this.targetEl.getAttribute("dir");
  }
  get isRtl() {
    return this.dir === "rtl";
  }
  get isLtr() {
    return !this.isRtl;
  }
  dispatchDirChangeEvent() {
    const t = new CustomEvent("wbdirchange", { detail: { dir: this.dir } });
    document.dispatchEvent(t);
  }
  createObserver() {
    this.observer = new MutationObserver(() => this.dispatchDirChangeEvent());
  }
  observe() {
    this.observer.observe(this.targetEl, Nt);
  }
}
const $t = { mq1: 320, mq2: 480, mq3: 768, mq4: 1024, mq5: 1280, mq6: 1440 }, Pt = "wbresize", Bt = ["mq2", "mq3", "mq4", "mq5", "mq6"];
let U = class de {
  constructor(t = window) {
    let n = de.smap.get(t);
    n || (n = (function(r) {
      const s = Bt.map((f) => [f, r.matchMedia(`(min-width: ${$t[f]}px)`)]).reverse();
      let c, a, i, o = 0;
      const u = () => i ??= requestAnimationFrame(l);
      function l() {
        i = void 0, c = a, a = d(), r.dispatchEvent(new CustomEvent(Pt, { detail: { current: a, previous: c } }));
      }
      function d() {
        for (const [f, S] of s) if (S.matches) return f;
        return "mq1";
      }
      return { getCurrentMediaQuery: d, observe: function(f = !1) {
        if (f && l(), o === 0) for (const [, S] of s) S.addEventListener("change", u);
        o++;
      }, disconnect: function() {
        if (o--, o === 0) for (const [, f] of s) f.removeEventListener("change", u);
      } };
    })(t), de.smap.set(t, n)), Object.assign(this, n);
  }
};
U.smap = /* @__PURE__ */ new Map();
new U(window);
new It(document.documentElement);
var Gt = Object.defineProperty, xt = ((e) => (e.Undefined = "undefined", e.Null = "null", e.String = "string", e.Number = "number", e.SpecialNumber = "number", e.Boolean = "boolean", e.BigInt = "bigint", e))(xt || {}), jt = ((e) => (e.Array = "array", e.Date = "date", e.Map = "map", e.Object = "object", e.RegularExpression = "regexp", e.Set = "set", e.Channel = "channel", e.Symbol = "symbol", e))(jt || {}), fe = typeof window < "u" ? window : {};
(() => {
  var e;
  let t = !1;
  try {
    (e = fe.document) == null || e.addEventListener("e", null, Object.defineProperty({}, "passive", { get() {
      t = !0;
    } }));
  } catch {
  }
  return t;
})();
var Ht = (() => {
  try {
    return new CSSStyleSheet(), typeof new CSSStyleSheet().replaceSync == "function";
  } catch {
  }
  return !1;
})();
Ht && (!!fe.document && Object.getOwnPropertyDescriptor(fe.document.adoptedStyleSheets, "length").writable);
((e, t) => {
  for (var n in t) Gt(e, n, { get: t[n], enumerable: !0 });
})({}, { err: () => Fe, map: () => qt, ok: () => pe, unwrap: () => zt, unwrapErr: () => Vt });
var pe = (e) => ({ isOk: !0, isErr: !1, value: e }), Fe = (e) => ({ isOk: !1, isErr: !0, value: e });
function qt(e, t) {
  if (e.isOk) {
    const n = t(e.value);
    return n instanceof Promise ? n.then((r) => pe(r)) : pe(n);
  }
  if (e.isErr) return Fe(e.value);
  throw "should never get here";
}
var zt = (e) => {
  if (e.isOk) return e.value;
  throw e.value;
}, Vt = (e) => {
  if (e.isErr) return e.value;
  throw e.value;
}, re = (e) => {
  const t = e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  return new RegExp(`(^|[^@]|@(?!supports\\s+selector\\s*\\([^{]*?${t}))(${t}\\b)`, "g");
};
re("::slotted"), re(":host"), re(":host-context");
function Wn(e = window) {
  return {
    currentStaticMediaQuery: new U(e).getCurrentMediaQuery()
  };
}
function Zn(e, t, n, r) {
  const s = (a) => {
    n(), a?.disconnect(), r?.logger?.debug(`fired load event for ${e} and query ${t}`);
  };
  function c(a) {
    if (a.shadowRoot) {
      const i = (u, l) => {
        if (!a.shadowRoot) throw new Error("element does not have a shadowRoot");
        const d = a.shadowRoot.querySelector(t);
        d && "complete" in d && d.complete ? s(l) : d && d.addEventListener("load", () => {
          s(l);
        });
      };
      new MutationObserver(i).observe(a.shadowRoot, { subtree: !0, childList: !0 });
    }
  }
  I(
    e,
    (a) => {
      a && customElements.whenDefined(a.localName).then(() => c(v(a)));
    },
    { immediate: !0 }
  );
}
/*! connection-aem-tracking 2.8.0 */
const Ue = "OWC_TRACKING_MANAGER", Te = "PUSH_TRACKING_EVENT", _e = { trackingEvents: [] };
new class extends Pe {
  constructor() {
    super(Ue);
  }
  get initialState() {
    return _e;
  }
  getReducer() {
    return (e = _e, t) => t.type === this.getActionType(Te) ? { ...e, trackingEvents: [...e.trackingEvents, t.payload] } : e;
  }
  getPublicDispatchers() {
    return { pushTrackingEvent: (e) => (window.top?.dataLayer_ow.push(e), this.getAction(Te, e)) };
  }
}();
const Ft = () => ve().getConnectionDispatchers(Ue).then(((e) => e));
function Ut(e) {
  return Xe() ? (et(e), !0) : !1;
}
const Qt = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const Yt = (e) => e != null, ae = () => {
};
function Wt(e) {
  return Array.isArray(e) ? e : [e];
}
function Zt(e, t, n) {
  return I(
    e,
    t,
    {
      ...n,
      once: !0
    }
  );
}
const Qe = Qt ? window : void 0;
function oe(e) {
  var t;
  const n = v(e);
  return (t = n?.$el) != null ? t : n;
}
// @__NO_SIDE_EFFECTS__
function Kt() {
  const e = ge(!1), t = Ie();
  return t && $(() => {
    e.value = !0;
  }, t), e;
}
// @__NO_SIDE_EFFECTS__
function Jt(e) {
  const t = /* @__PURE__ */ Kt();
  return E(() => (t.value, !!e()));
}
function Xt(e, t, n = {}) {
  const {
    root: r,
    rootMargin: s = "0px",
    threshold: c = 0,
    window: a = Qe,
    immediate: i = !0
  } = n, o = /* @__PURE__ */ Jt(() => a && "IntersectionObserver" in a), u = E(() => {
    const A = v(e);
    return Wt(A).map(oe).filter(Yt);
  });
  let l = ae;
  const d = ge(i), f = o.value ? I(
    () => [u.value, oe(r), d.value],
    ([A, g]) => {
      if (l(), !d.value || !A.length)
        return;
      const b = new IntersectionObserver(
        t,
        {
          root: oe(g),
          rootMargin: s,
          threshold: c
        }
      );
      A.forEach((h) => h && b.observe(h)), l = () => {
        b.disconnect(), l = ae;
      };
    },
    { immediate: i, flush: "post" }
  ) : ae, S = () => {
    l(), f(), d.value = !1;
  };
  return Ut(S), {
    isSupported: o,
    isActive: d,
    pause() {
      l(), d.value = !1;
    },
    resume() {
      d.value = !0;
    },
    stop: S
  };
}
function en(e, t = {}) {
  const {
    window: n = Qe,
    scrollTarget: r,
    threshold: s = 0,
    rootMargin: c,
    once: a = !1
  } = t, i = ge(!1), { stop: o } = Xt(
    e,
    (u) => {
      let l = i.value, d = 0;
      for (const f of u)
        f.time >= d && (d = f.time, l = f.isIntersecting);
      i.value = l, a && Zt(i, () => {
        o();
      });
    },
    {
      root: r,
      window: n,
      threshold: s,
      rootMargin: v(c)
    }
  );
  return i;
}
var tn = /* @__PURE__ */ ((e) => (e.CAMPAIGN = "campaign", e.SLEEK = "sleek", e.YOUNGSTARS = "young_stars", e.RICH = "rich", e))(tn || {});
const Le = {
  eventName: "view_promotion",
  category: "impression",
  label: void 0
  // no label for impression regarding documentation
}, Kn = {
  eventName: "select_promotion",
  category: "link",
  label: "teaser"
  /* TEASER */
}, Jn = {
  eventName: "select_promotion",
  category: "link"
  /* LINK */
};
function Xn(e, t) {
  let n = null;
  tt(async () => {
    n ||= await Ft();
  });
  function r(c, a) {
    const i = m(!1), o = en(c), u = I(
      o,
      (l) => {
        l && !i.value && (i.value = !0, a ? s(Le, a) : s(Le), u?.());
      },
      { immediate: !0 }
    );
  }
  async function s(c, a) {
    const i = {
      event: "click",
      eventDetail: {
        name: c.eventName,
        category: c.category,
        action: `banner.${e}`,
        label: c.label,
        URL: c.URL ?? void 0,
        promotion: a
      },
      application: {
        id: "seamless_emh",
        version: "",
        subId: "vehicles",
        type: void 0,
        parentApplicationId: "aem",
        businessUnit: t?.value?.toLowerCase() ?? void 0
      }
    };
    typeof requestIdleCallback == "function" ? requestIdleCallback(() => {
      n?.pushTrackingEvent(i);
    }) : n?.pushTrackingEvent(i);
  }
  return {
    track: s,
    trackVisibility: r
  };
}
var nn = typeof global == "object" && global && global.Object === Object && global, rn = typeof self == "object" && self && self.Object === Object && self, Ye = nn || rn || Function("return this")(), q = Ye.Symbol, We = Object.prototype, an = We.hasOwnProperty, on = We.toString, B = q ? q.toStringTag : void 0;
function sn(e) {
  var t = an.call(e, B), n = e[B];
  try {
    e[B] = void 0;
    var r = !0;
  } catch {
  }
  var s = on.call(e);
  return r && (t ? e[B] = n : delete e[B]), s;
}
var cn = Object.prototype, un = cn.toString;
function ln(e) {
  return un.call(e);
}
var dn = "[object Null]", fn = "[object Undefined]", Re = q ? q.toStringTag : void 0;
function pn(e) {
  return e == null ? e === void 0 ? fn : dn : Re && Re in Object(e) ? sn(e) : ln(e);
}
function mn(e) {
  return e != null && typeof e == "object";
}
var En = "[object Symbol]";
function gn(e) {
  return typeof e == "symbol" || mn(e) && pn(e) == En;
}
var vn = /\s/;
function bn(e) {
  for (var t = e.length; t-- && vn.test(e.charAt(t)); )
    ;
  return t;
}
var Sn = /^\s+/;
function hn(e) {
  return e && e.slice(0, bn(e) + 1).replace(Sn, "");
}
function me(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Oe = NaN, yn = /^[-+]0x[0-9a-f]+$/i, Cn = /^0b[01]+$/i, wn = /^0o[0-7]+$/i, An = parseInt;
function ke(e) {
  if (typeof e == "number")
    return e;
  if (gn(e))
    return Oe;
  if (me(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = me(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = hn(e);
  var n = Cn.test(e);
  return n || wn.test(e) ? An(e.slice(2), n ? 2 : 8) : yn.test(e) ? Oe : +e;
}
var se = function() {
  return Ye.Date.now();
}, Mn = "Expected a function", Tn = Math.max, _n = Math.min;
function Ln(e, t, n) {
  var r, s, c, a, i, o, u = 0, l = !1, d = !1, f = !0;
  if (typeof e != "function")
    throw new TypeError(Mn);
  t = ke(t) || 0, me(n) && (l = !!n.leading, d = "maxWait" in n, c = d ? Tn(ke(n.maxWait) || 0, t) : c, f = "trailing" in n ? !!n.trailing : f);
  function S(p) {
    var M = r, P = s;
    return r = s = void 0, u = p, a = e.apply(P, M), a;
  }
  function A(p) {
    return u = p, i = setTimeout(h, t), l ? S(p) : a;
  }
  function g(p) {
    var M = p - o, P = p - u, ye = t - M;
    return d ? _n(ye, c - P) : ye;
  }
  function b(p) {
    var M = p - o, P = p - u;
    return o === void 0 || M >= t || M < 0 || d && P >= c;
  }
  function h() {
    var p = se();
    if (b(p))
      return R(p);
    i = setTimeout(h, g(p));
  }
  function R(p) {
    return i = void 0, f && r ? S(p) : (r = s = void 0, a);
  }
  function O() {
    i !== void 0 && clearTimeout(i), u = 0, r = o = s = i = void 0;
  }
  function k() {
    return i === void 0 ? a : R(se());
  }
  function N() {
    var p = se(), M = b(p);
    if (r = arguments, s = this, o = p, M) {
      if (i === void 0)
        return A(o);
      if (d)
        return clearTimeout(i), i = setTimeout(h, t), S(o);
    }
    return i === void 0 && (i = setTimeout(h, t)), a;
  }
  return N.cancel = O, N.flush = k, N;
}
let j;
const Rn = () => j = new U(window), De = (e, t = 300) => {
  const n = Ln(e, t);
  $(() => {
    y.addResizeEventListener(n);
  }), Ne(() => {
    y.removeResizeEventListener(n);
  });
}, y = {
  /**
   * Gets the current breakpoint.
   * @returns {string} - Current breakpoint.
   */
  getCurrentBreakpoint() {
    return j?.getCurrentMediaQuery().toLowerCase() || "mq1";
  },
  /**
   * Adds a resize event listener.
   * @param {Function} callback - Callback function for resize events.
   */
  addResizeEventListener(e) {
    window.addEventListener("wbresize", e), j.observe(!0);
  },
  /**
   * Removes a resize event listener.
   * @param {Function} callback - Callback function to remove.
   */
  removeResizeEventListener(e) {
    window.removeEventListener("wbresize", e), j.disconnect();
  },
  /**
   * Checks if the viewport is mobile.
   * @returns {boolean} - True if mobile, false otherwise.
   */
  isMobile() {
    return ["mq1", "mq2", "mq3"].includes(y.getCurrentBreakpoint());
  },
  /**
   * Checks if the viewport is tablet.
   * @returns {boolean} - True if tablet, false otherwise.
   */
  isTablet() {
    return ["mq1", "mq2", "mq3", "mq4"].includes(y.getCurrentBreakpoint());
  },
  /**
   * Checks if the viewport is desktop.
   * @returns {boolean} - True if desktop, false otherwise.
   */
  isDesktop() {
    return ["mq5", "mq6"].includes(y.getCurrentBreakpoint());
  }
}, er = () => {
  const e = m(y.getCurrentBreakpoint()), t = m(y.isMobile()), n = m(y.isTablet()), r = m(y.isDesktop());
  return $(async () => {
    Rn();
  }), De(() => {
    n.value = y.isTablet(), t.value = y.isMobile(), r.value = y.isDesktop(), e.value = y.getCurrentBreakpoint();
  }), {
    breakpoint: e,
    isTablet: n,
    isMobile: t,
    isDesktop: r,
    onWindowResize: De
  };
}, ie = {
  MERCEDES_BENZ: {
    LEFT: ["A_CLASS", "B_CLASS", "CLA_CLASS", "GLA_CLASS", "GLB_CLASS", "EQA_CLASS", "EQB_CLASS", "EQT_CLASS"],
    CENTER: ["C_CLASS", "GLC_CLASS", "E_CLASS", "CLE_CLASS", "V_CLASS", "EQV_CLASS"],
    // temp solution: Removing EQE_CLASS, long term adjustments in inflate
    RIGHT: ["GLE_CLASS", "EQE_CLASS", "EQS_CLASS", "GLS_CLASS", "G_CLASS", "S_CLASS"]
  },
  MERCEDES_AMG: {
    LEFT: ["A_CLASS", "CLA_CLASS"],
    CENTER: ["C_CLASS", "GLC_CLASS", "E_CLASS", "EQE_CLASS"],
    RIGHT: ["GLE_CLASS", "EQE_CLASS", "EQS_CLASS", "GLS_CLASS", "G_CLASS", "S_CLASS", "SL_CLASS", "GT_CLASS"]
  },
  MERCEDES_MAYBACH: {
    LEFT: ["GLS_CLASS"],
    CENTER: ["S_CLASS"],
    RIGHT: ["EQS_CLASS"]
  },
  get "Mercedes-Benz"() {
    return ie.MERCEDES_BENZ;
  },
  get "Mercedes-AMG"() {
    return ie.MERCEDES_AMG;
  },
  get "Mercedes-Maybach"() {
    return ie.MERCEDES_MAYBACH;
  }
}, tr = [
  "TR",
  "TH",
  "KR",
  "AU",
  "JP",
  "SG",
  "MY",
  "ZA",
  // 'ZS' in the fincalc list
  "NZ",
  "IN",
  "MX",
  "TW",
  "VN",
  "BR",
  "EG"
], nr = {
  LEFT: ["SPRINTER"],
  CENTER: ["VITO", "CITAN"],
  RIGHT: ["eCITAN", "eSPRINTER", "eVITO"]
};
function rr(e) {
  return Object.keys(e).filter((t) => e[t]).join(",");
}
function ar(e) {
  return Array.isArray(e) ? e.join(",") : "";
}
const or = (e, t) => e.map((n, r) => On(n, r, t)), On = (e, t, n) => ({
  id: void 0,
  name: "not set",
  creative: e.split("/").pop(),
  position: `banner_${n}.${t}`
}), sr = (e, t) => {
  e.ctrlKey || e.metaKey ? window.open(t, "_blank") : window.location.assign(t);
}, ir = (e) => ["B2B", "B2C"].includes(e);
function* cr(...e) {
  const t = e.map((n) => n[Symbol.iterator]());
  for (; ; ) {
    const n = t.map((r) => r.next());
    if (n.some(({ done: r }) => r)) break;
    yield n.map(({ value: r }) => r);
  }
}
export {
  Kn as BannerClickEvent,
  tn as BannerType,
  Hn as COMPONENT_ID_SYMBOL,
  Ot as ComponentCategory,
  Jn as CtaClickEvent,
  jn as DARK_MODE_SUBBRANDS,
  qn as DEFAULT_BRAND,
  Le as ImpressionEvent,
  W as ONE_TEASER,
  tr as OVERSEAS_MARKETS,
  X as PHRASE_COMPARE,
  K as PHRASE_DCP,
  J as PHRASE_ONE_TEASER,
  kt as Severity,
  Bn as VEHICLE_TILE,
  Ae as aemLoaded,
  ar as arrayToJoinedString,
  ie as brandToModelMap,
  St as buildConfigServiceUrl,
  On as convertBannerItemToTrackingItem,
  or as convertBannerItemsToTrackingItems,
  Et as convertBrandToOurs,
  ue as country,
  we as environment,
  ir as isContextType,
  le as language,
  Mt as locale,
  Dt as logError,
  Vn as market,
  Rt as marketId,
  Ct as mbtiDiscoAirConnectionName,
  rr as objectToJoinedString,
  gt as parseEnvironment,
  nr as positionDefinesModel,
  Me as raise,
  sr as urlLinkout,
  Un as useAemEnvironmentConnection,
  Qn as useAppearance,
  Xn as useBannerTracking,
  Pn as useBrand,
  Gn as useConfigService,
  xn as useDummyConfig,
  Yn as useErrorCapturer,
  Fn as useI18n,
  Wn as useMediaQuery,
  Zn as useSubscribeToLoadEventInShadowRoot,
  dr as useUuid,
  zn as useVehicleTileData,
  er as useViewport,
  cr as zip
};
//# sourceMappingURL=index.js.map
